const CreateReport_mutate = `
    mutation createReport(
      $issue: String!,
	  $note: String!,
      $objectId: Int!,
      $objectUuid: String!,
	  $contentType: String!) {
      createReport(
        issue: $issue,
		note: $note,
        objectId: $objectId,
        objectUuid: $objectUuid,
		contentType: $contentType) {
          reportId
      }
    }
`;

const AllReportsList_query = `query{
  allReports{
    reportId
    uuid
    objectId
    objectUuid
    contentType{
      model
    }
    objectOwner{
      id
      userUuid
      firstName
      lastName
      username
      avatarFileName
    }
    objectImage
    reportedBy
    reportedByUserUuid    
    dateReported
    dateResolved
    issue
    note
    status
  }
}`;

const DeleteReportById_mutate = `mutation deleteReportById($reportId: Int!) {
    deleteReportById(reportId: $reportId) {
      success
      msg
    }
  }
`;

const ReportByUuid_query = `query($uuid: String!){
  reportByUuid(uuid: $uuid){
    reportId
    uuid
    reportedBy
    reportedByUserUuid
    objectId
    objectUuid
    contentType{
      model
    }
    objectOwner{
      username
      userUuid
    }
    objectTitle
    dateReported
    dateReviewed
    dateResolved
    issue
    note
    status
    createBy
    createDate
    updateBy
    updateDate
  }  
}`;

const EditReport_mutate = `
    mutation editReport(
      $reportUuid: String!,
      $note: String!,
      $status: String!,
      ) {
      editReport(
        reportUuid: $reportUuid,
        note: $note,
        status: $status) {
        
        report
        {
          uuid
          reportId
        }
      }
    }
`;

module.exports = {
  CREATE_REPORT_MUTATION : CreateReport_mutate,
  ALL_REPORTS_LIST: AllReportsList_query,
  DELETE_REPORT_BY_ID: DeleteReportById_mutate,
  REPORT_BY_UUID: ReportByUuid_query,
  EDIT_REPORT_MUTATION: EditReport_mutate
}
